module.exports = __webpack_public_path__ + "static/media/powermax.47c15954.png";